<script >
	
	import { loginUser } from "../../api/Login";

	import {encrypt} from "../../services/crypto";

	export let changeToRegister = false;

	import  CryptoJS from "crypto-js";

	let userData = {
		Email: "",
		Password: ""
	}

	let errorMessage = '';

	function handleKeepMeLogedIn(e){

		console.log(e.target.checked);
	}

	function handleGoToRegisterBtn(){

		changeToRegister = true;
	}


	async function encryptData(data){

		
		var res = encrypt(data);

		// var bytes  = CryptoJS.AES.decrypt(res, 'secret key 123');
		// var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

		// console.log('decrypted:',decryptedData);

		return res;
	}

	async function handleLoginBtn(){
		
		const userDataAux = [];

		userDataAux[0] = userData.Email;
		userDataAux[1] = userData.Password;

		var encryptedData = await encryptData(userData);

		const res = await loginUser(encryptedData);

		if(res.status == "valid"){
			localStorage.setItem('user', JSON.stringify(res.user));
      		localStorage.setItem('token', res.token);
      		window.location.href = '/';
		}
		else if(res.status == "error"){
			if(res.code == "ENF"){
				errorMessage = res.error;
				userData.Email = '';
				var el = document.getElementById("Email");
				el.classList.remove('loginInput');
				el.classList.add('errorLoginInput');
			}
			else if(res.code == "IP"){
				errorMessage = res.error;
				userData.Email = userDataAux[0];
				userData.Password = null;
				var el = document.getElementById("Password");
				el.classList.remove('loginInput');
				el.classList.add('errorLoginInput');
			}
			else if(res.code == "LF"){
				errorMessage = res.error;
			}
		}	
	}

</script>

<div class="loginContainer">

	<div class="logoContainer">
		<div class="artisaneLogo"></div>
	</div>

	<div class="loginInputContainer">
		<p class="errorMessage">{errorMessage}</p>
		<input bind:value={userData.Email} class="loginInput" id="Email" type="email" name="Email"  placeholder="Email">
		<input bind:value={userData.Password} class="loginInput" id="Password" type="password" name="Password" placeholder="Password">

	</div>

	<div class="loginActionsContainer">

		<div class="sessionContainer">

			<div class="keepMeLogedInContainer">

				<input on:click={(e) => handleKeepMeLogedIn(e)} class="checkBox" type="checkbox" id="keepMeLogedIn" name="keepMeLogedIn" unchecked>

				<div class="ckeckBoxLabel" for="keepMeLogedIn">Keep me loged in</div>

			</div>

			<a class="passwordRecoveryLink">Forgot your password?</a>
			
		</div>

		<div on:click={handleLoginBtn} class="loginSubmitBtn">Log In</div>

		<div class="goToRegisterText">
			Dont't have an account?

			<a on:click={handleGoToRegisterBtn} class="goToRegisterLink">Join us.</a>

		</div>
	</div>
</div>


<style>

:global(.errorLoginInput) {
        	width: 90%;
		/*height: 40px;*/
		height: 5.54016620498615vh;
		border: 1px solid red;
		border-radius: 3px;	
}

/*Login section for mobile*/
@media only screen and (max-width: 600px){


	.loginContainer{
		width: 50%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		

	}

	.logoContainer{
		width: 50%;
		height: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		
	}
	.artisaneLogo{
		width: 200px;
		height: 200px;
		background-image: url('/img/logos/artisaneBig.png');
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center center;
	}


	.loginInputContainer{
		width: 50%;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		
	}

	.errorMessage{
		
		font-size: 0.78125vw;
		color: red;
	}

	.loginInput{
		width: 90%;
		height: 5.54016620498615vh;
	}	

	.loginActionsContainer{
		width: 50%;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

	}


	.sessionContainer{
		width: 90%;
		height: 5.54016620498615vh;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-top:2% ;
	}

	.keepMeLogedInContainer{
		width: 50%;
		height: auto;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		
	}

	.checkBox{
		width: 1.3020833333333333vw;
		height: 2.770083102493075vh;
	}

	.ckeckBoxLabel{
		width: 90% ;
		height: auto;
		display: flex;
		justify-content: center;
		line-height: 60%;
		font-size: 0.9114583333333334vw;
	}

	.passwordRecoveryLink{
		width: 50%;
		height: auto;
		color: black;
		opacity: 0.3 !important;
		display: flex;
		line-height: 60%;
		justify-content: flex-end;
		cursor: pointer;
		font-size: 0.9114583333333334vw;

	}

	.loginSubmitBtn{
		width: 90%;
		height: 5.54016620498615vh;
		background-color: black;
		color:  white;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top:5% ;
		border-radius: 3px;
		cursor: pointer;
	}

	.goToRegisterText{
		margin-top:5% ;
		font-size: 0.9114583333333334vw;

	}
	.goToRegisterLink{
		font-size: 0.9114583333333334vw;
		color: #EF9144;
		text-decoration: underline;
		cursor: pointer;
	}

	.goToRegisterLink:hover{
		opacity: 0.8;
	}
	.goToRegisterLink:active{
		color: black;
	}
}

/*Login section for desktop*/
@media only screen and (min-width: 768px){

	.loginContainer{
		width: 50%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		/*background-color: red;*/

	}

	.logoContainer{
		width: 50%;
		height: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		/*background-color: gray;*/
	}
	.artisaneLogo{
		width: 200px;
		height: 200px;
		background-image: url('/img/logos/artisaneBig.png');
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center center;
	}


	.loginInputContainer{
		width: 50%;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		/*background-color: gray;*/
		/*gap:5px;*/
	}

	.errorMessage{
		/*font-size: 12px;*/
		font-size: 0.78125vw;
		color: red;
	}

	.loginInput{
		width: 90%;
		/*height: 40px;*/
		height: 5.54016620498615vh;
	}	

	.loginActionsContainer{
		width: 50%;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		/*gap: 20%;*/
		/*background-color: gray;*/

	}


	.sessionContainer{
		width: 90%;
		/*height: 40px;*/
		height: 5.54016620498615vh;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		/*background-color: red;*/
		margin-top:2% ;
	}

	.keepMeLogedInContainer{
		width: 50%;
		height: auto;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		
	}

	.checkBox{
		/*width: 20px;*/
		/*height: 20px;*/
		width: 1.3020833333333333vw;
		height: 2.770083102493075vh;
	}

	.ckeckBoxLabel{
		/*background-color: red;*/
		width: 90% ;
		height: auto;
		display: flex;
		/*align-items: center;*/
		justify-content: center;
		line-height: 60%;
		font-size: 0.9114583333333334vw;
	}

	.passwordRecoveryLink{
		width: 50%;
		height: auto;
		color: black;
		opacity: 0.3 !important;
		display: flex;
		/*align-items: center;*/
		line-height: 60%;
		justify-content: flex-end;
		cursor: pointer;
		font-size: 0.9114583333333334vw;

	}

	.loginSubmitBtn{
		width: 90%;
		/*height: 40px;*/
		height: 5.54016620498615vh;
		background-color: black;
		color:  white;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top:5% ;
		border-radius: 3px;
		cursor: pointer;
	}

	.goToRegisterText{
		margin-top:5% ;
		font-size: 0.9114583333333334vw;

	}
	.goToRegisterLink{
		font-size: 0.9114583333333334vw;
		color: #EF9144;
		text-decoration: underline;
		cursor: pointer;
	}

	.goToRegisterLink:hover{
		opacity: 0.8;
	}
	.goToRegisterLink:active{
		color: black;
	}

}
</style>